import React from 'react';

import { JING_YANG_TRENDING_POST_IMG_URL, JING_YANG_TRENDING_VIDEO_URL } from './constants';

interface AsiaBureauChiefVideoProps {
  videoRef?: React.RefObject<HTMLVideoElement>;
}

const AsiaBureauChiefVideo = ({ videoRef }: AsiaBureauChiefVideoProps) => (
  <>
    <h2 className="text-center font-suisse-neue text-body-md sm:text-subheadline-sm">
      Get to know our Asia Bureau Chief Jing Yang
    </h2>
    <div className="aspect-[16/9] w-full">
      <video
        ref={videoRef}
        className="h-full w-full"
        poster={JING_YANG_TRENDING_POST_IMG_URL}
        preload="metadata"
        src={JING_YANG_TRENDING_VIDEO_URL}
        controls
        playsInline
      />
    </div>
  </>
);

export default AsiaBureauChiefVideo;
